import { SfSelectOption } from 'ngx-smart-form';
import { NaturaGiuridicaEnum } from '../models/natura-giuridica.enum';

export const NATURA_GIURIDICA_OPTIONS: Readonly<SfSelectOption>[] = [
  { value: NaturaGiuridicaEnum.ALTRO, view: '-' },
  { value: NaturaGiuridicaEnum.PA, view: NaturaGiuridicaEnum.PA },
  { value: NaturaGiuridicaEnum.SS, view: NaturaGiuridicaEnum.SS },
  { value: NaturaGiuridicaEnum.SAS, view: NaturaGiuridicaEnum.SAS },
  { value: NaturaGiuridicaEnum.SNC, view: NaturaGiuridicaEnum.SNC },
  { value: NaturaGiuridicaEnum.STP, view: NaturaGiuridicaEnum.STP },
  { value: NaturaGiuridicaEnum.SRL, view: NaturaGiuridicaEnum.SRL },
  {
    value: NaturaGiuridicaEnum.SAPA,
    view: NaturaGiuridicaEnum.SAPA,
  },
  { value: NaturaGiuridicaEnum.SPA, view: NaturaGiuridicaEnum.SPA },
  { value: NaturaGiuridicaEnum.FON, view: NaturaGiuridicaEnum.FON },
  { value: NaturaGiuridicaEnum.COOP, view: NaturaGiuridicaEnum.COOP },
  { value: NaturaGiuridicaEnum.CONS, view: NaturaGiuridicaEnum.CONS },
  { value: NaturaGiuridicaEnum.ASSO, view: NaturaGiuridicaEnum.ASSO },
  { value: NaturaGiuridicaEnum.FOUN, view: NaturaGiuridicaEnum.FOUN },
  { value: NaturaGiuridicaEnum.FOUNB, view: NaturaGiuridicaEnum.FOUNB },
  { value: NaturaGiuridicaEnum.SA, view: NaturaGiuridicaEnum.SA },
  { value: NaturaGiuridicaEnum.TRU, view: NaturaGiuridicaEnum.TRU },
];
